import { render } from "./PasswordReset.vue?vue&type=template&id=66fc1d19"
import script from "./PasswordReset.vue?vue&type=script&setup=true&lang=js"
export * from "./PasswordReset.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/PasswordReset.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "66fc1d19"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('66fc1d19', __exports__)) {
    api.reload('66fc1d19', __exports__)
  }
  
  module.hot.accept("./PasswordReset.vue?vue&type=template&id=66fc1d19", () => {
    api.rerender('66fc1d19', render)
  })

}


export default __exports__